import { AiDocumentStatus, AiDocumentSummary } from '../../../../common/ai.dictionary'

const BG_COLOR_IN_PROGRESS = 'bg-yellow-600'
const BG_COLOR_SUCCESS = 'bg-green-400'
const BG_COLOR_FAILED = 'bg-red-500'
const statusPropsMap: Record<
  AiDocumentStatus,
  {
    bgColor: string
    label: string
    tooltip: string
  }
> = {
  [AiDocumentStatus.NOT_PROCESSED]: {
    bgColor: BG_COLOR_IN_PROGRESS,
    label: 'Not processed',
    tooltip: 'Document has not been processed yet',
  },
  [AiDocumentStatus.UPLOADING]: {
    bgColor: BG_COLOR_IN_PROGRESS,
    label: 'Uploading',
    tooltip: 'File is being uploaded.',
  },
  [AiDocumentStatus.UPLOADED]: {
    bgColor: BG_COLOR_IN_PROGRESS,
    label: 'Uploaded',
    tooltip: 'File was uploaded.',
  },
  [AiDocumentStatus.SUMMARIZING]: {
    bgColor: 'bg-yellow-600',
    label: 'Summarizing',
    tooltip: 'Generating document summary.',
  },
  [AiDocumentStatus.SUMMARIZED]: {
    bgColor: BG_COLOR_SUCCESS,
    label: 'Summarized',
    tooltip: 'Document summary generated.',
  },
  [AiDocumentStatus.PROCESSING]: {
    bgColor: BG_COLOR_IN_PROGRESS,
    label: 'processing',
    tooltip: 'Document is being processed.',
  },
  [AiDocumentStatus.PROCESSED]: {
    bgColor: BG_COLOR_IN_PROGRESS,
    label: 'processed',
    tooltip: 'Document has been processed.',
  },
  [AiDocumentStatus.READY]: {
    bgColor: BG_COLOR_SUCCESS,
    label: 'Ready',
    tooltip: 'Document can be used for generating.',
  },
  // TODO: this status should be removed from ai first
  [AiDocumentStatus.EVALUATED]: {
    bgColor: BG_COLOR_SUCCESS,
    label: 'Ready',
    tooltip: 'Document can be used for generating.',
  },
  [AiDocumentStatus.FAILED]: {
    bgColor: BG_COLOR_FAILED,
    label: 'Failed',
    tooltip: 'Something went wrong while uploading and processing.',
  },
}
export const fetchStatusPropsByType = (
  status: AiDocumentSummary['status']
): { bgColor: string; label: string; tooltip: string } => statusPropsMap[status]
